export let app: ng.IModule = angular.module('app', ['ngAnimate']);


/** WEBPACK FOOTER **
 ** ./app/app-module.ts
 **/